import React, {Component} from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import Modal from 'react-responsive-modal';
// import StickyHeader from '../../components/onboarding/StickyHeader';
import WishlistReviewProduct from '../../components/wishlist/WishlistReviewProduct';
// cart 所需文件
import { Elements,StripeProvider } from 'react-stripe-elements';
import RecommendationsCheckout from '../../views/recommendations/RecommendationsCheckout';
// 操作cart 的方法
import { addOrDeleteCartGoodsData,deleteAllCartGoodsData } from '../../actions/cartAction';

import Api from '../../utils/api';

import './Wishlist.css';

class Wishlist extends Component {
    constructor(props){
        super(props);

        this.products = [];

        this.state = {
            productWishlist: [],
            // 购物车参数。如果还有别的地方需要把购物车打开。那这些参数都需要 reducer
            openPaymentConfirmModal: false, 
            amountAvailableForDiscount: 0, 
            discountCodes: [],   // 目前没用
            promoCodeSaved: "",
            loadingPurchase: false,
            eligibleForDiscount: localStorage.getItem('recoeligiblefordiscount') ? localStorage.getItem('recoeligiblefordiscount'): false,
            eligiblePreviouslyPurchased: localStorage.getItem("recohasnotpurchased") ? localStorage.getItem("recohasnotpurchased"): false,
            productArr:[],
            purchasedProduct:false,
            cartGoodsList:this.props.cartGoodsList,
            orderEnd:false, // Whether to complete the purchase
            orderId: '',
            orderSubtotal: 0,
        }

        this.syncProducts = this.syncProducts.bind(this);
        this.handleCheckout = this.handleCheckout.bind(this);
    }

    componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (userId) {
            this.getWishlist();
            this.checkIfPreviouslyPurchased();
            this.checkIfPaidGateFee();
        } else {
            // localStorage.setItem('visited_recommendations', true);
            this.props.history.push('/signin');
        }
    }

    getWishlist() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/wished-products?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ 
                productWishlist: responseJson });
        }).catch(function(err) {
            alert("There was a problem getting your wishlist. Please refresh the page and try again.");
        });
    
    }

    checkIfPreviouslyPurchased() {
        const userId = localStorage.getItem("user_id");

        fetch('/api/user-orders/extended-with-products?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            if (responseJson && responseJson.length < 1) this.setState({ hasNeverPurchased: true });
            else this.setState({ hasNeverPurchased: false });
        }).catch(function(err) {
            alert("There is a problem to get the orders. Please try again.");
        });
    }

    checkIfPaidGateFee() {
        const userId = localStorage.getItem("user_id"); 
        fetch('/api/user-flags/gate-fee-paid?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({ userPaidGateFee: true });
            }
        })
        .catch(function(err) {
            alert("There was a problem getting the confirmation code. Please try again.");
        });
    }

    syncProducts(prev, curr) {
        let arr = this.products;
        let i = arr.indexOf(prev);

        if(i !== -1){
            arr.splice(i, 1);
        }

        if(curr.indexOf(":0") === -1) {
            arr.push(curr);
        }
        this.products = arr;
    }

    handleCheckout() {
        const count = this.products.reduce((res, val) => res + parseInt(val.split(":")[1],10), 0);
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
        }

        let url = "";
        if (this.state.userPaidGateFee) {
            if (this.state.hasNeverPurchased) {
                url = 'https://helloava.myshopify.com/cart/' + this.products.toString() + '?discount=curationfeepurchasecredit10';
             } else {
                url = 'https://helloava.myshopify.com/cart/' + this.products.toString();
             }
        } else {
            url = 'https://helloava.myshopify.com/cart/' + this.products.toString();
        }
        window.open(url);
        // if (process.env.REACT_APP_ENV === 'prod') {
        //     ReactGA.event({
        //         category: 'Checkout Funnel',
        //         action: 'Click',
        //         label: 'Checkout',
        //         value: 1
        //     });
        // }
    }

    // 打开购物车，判断购物车中数量
    openPaymentConfirmModal = () => {
        const count = this.props.cartGoodsList.length
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
        }
        this.setState({ openPaymentConfirmModal: true });
      }
  
    // 关闭付款页面/购物车页面
    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
    }

    // 从购物车页面中删除购物车中的产品
    handleDeleteProduct = (product) => {
    let productArr = this.props.cartGoodsList;
    const ind = productArr.indexOf(product);
    let productArrCopy = [];
    if (ind < 0) {
        productArrCopy = [...productArr, product];
    } else {
        productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
    }
    if (productArrCopy < 1) this.setState({ openPaymentConfirmModal: false });

    this.props.addOrDeleteCartGoodsData(product)
    this.setState({ productArr: productArrCopy }, () => {
        if (this.state.productArr.length < 1) this.setState({ openPaymentConfirmModal: false });
    });
    }
    
    // 关闭付款页面/购物车页面
    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
    }

    // 强制渲染，没有必要
    forceRender = () => {
        this.setState({
            cartGoodsList:this.props.cartGoodsList
        })
    }
    
    toggleLoading= (loadingPurchase) => {
      this.setState({ loadingPurchase: loadingPurchase });
    }
    // 在购物车中，完成购买后。展示ThankYou,关闭购物车页面。清空 localStorage
    showThankYou = (orderIdValue,orderSubtotalValue,sourceOrderId,orderProductsDataValue, goodsNumber) => {
      this.setState({ openPaymentConfirmModal: true, runTutorial: false }, () => {
        for (let key in localStorage) {
          if (key.includes("reco") && !key.includes("enable_")) localStorage.removeItem(key);
        }
        localStorage.removeItem('cart-products-ids');
        this.props.history.push({pathname:"/showThankYou",state:{'orderId':orderIdValue,'orderSubtotal':orderSubtotalValue,'sourceOrderId':sourceOrderId,'orderProductsData':orderProductsDataValue,'orderGoodsNumber':goodsNumber }});
      });
    }

    render() {
        const productWishlist = this.state.productWishlist;
        let productWishlistStream = productWishlist.map(product => {
            return(
                <div className="wishlist-product">
                    <WishlistReviewProduct 
                        product={product}
                        page={1}
                        syncProducts={ this.syncProducts }
                        saveCartForLater={ this.props.addOrDeleteCartGoodsData }
                        cartData={this.state.cartGoodsList}
                    />
                </div>
            );
        });

        return (
            <div id="wishlist" style={{marginTop:'2em'}}>
            <Helmet>
                <title>Wishlist - HelloAva</title>
            </Helmet>
               {/* <div id="links">
                    <div id="links-section" className="links-section">
                        <StickyHeader
                            height={51}
                            page="left" 
                            left="WISHLIST" 
                            right="REVIEWED PRODUCTS"
                            leftLink="/wishlist"
                            rightLink="/reviewed-products"
                        />
                    </div>
                </div>*/}
                <div id="wishlist-section" className="wishlist-section">
                        <div className="wishlist-body">
                            {productWishlistStream}
                        </div>
                </div>

                <div className="checkout-section">
                    {/* <button className="view-my-recommendations-button" onClick={this.handleCheckout}>Check out</button> */}
                    <button className="view-my-recommendations-button" onClick={ ()=>{this.openPaymentConfirmModal() }}>Check out</button>
                </div>


                <Modal open={ this.state.openPaymentConfirmModal } onClose={ this.closePaymentConfirmModal }
                  classNames={{ overlay: 'ha-overlay payment-confirm-overlay', modal: 'ha-modal payment-confirm-modal', closeIcon: 'ha-modal-close' }} focusTrapped={ true }>
                    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
                    <Elements>
                            <RecommendationsCheckout 
                                    productArr={ this.props.cartGoodsList}
                                    price={ this.props.cartPriceSum() }
                                    amountPaidGateFee={ localStorage.getItem("recogateamount") || this.state.amountPaidGateFee }
                                    name={ localStorage.getItem("user_firstname") + " " + localStorage.getItem("user_lastname")}

                                    discountCodes={ this.state.discountCodes }
                                    eligibleForDiscount={ this.state.eligibleForDiscount }
                                    hasNotPurchased={ this.state.eligiblePreviouslyPurchased }


                                    handleDeleteProduct={ this.handleDeleteProduct }
                                    forceRender={ this.forceRender }
                                    toggleLoading={ this.toggleLoading }
                                    showThankYou={ this.showThankYou }
                                    clearCart={ this.props.deleteAllCartGoodsData }
                                    saveCartForLater={ this.props.addOrDeleteCartGoodsData }
                                    productCart={ this.props.cartGoodsList }
                            />
                    </Elements>
                        </StripeProvider>    
                </Modal>
               

            </div>
        );
    }
}


function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { isAuthenticated,cartGoodsCount,cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
        addOrDeleteCartGoodsData: (product,actonType) => dispatch(addOrDeleteCartGoodsData(product,actonType)),
        deleteAllCartGoodsData: () => dispatch(deleteAllCartGoodsData())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Wishlist));



// WEBPACK FOOTER //
// ./src/views/wishlist/Wishlist.js